import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useRouter } from "next/router";
import { handleFiveSecTimeSpentEvent } from "../utils/helperEventFunctions";

// Triggers an event every 5sec, in order to measure the timeSpent
const useFiveSecTimeSpent = () => {
  const currentUser = useSelector((state) => state?.currentUser?.currentUser);
  const firebaseUID = useSelector((state) => state?.currentUser?.firebaseUID);
  const userName = currentUser?.name;
  const userId = currentUser?.id;
  const router = useRouter();
  const screen = router.pathname;

  useEffect(() => {
    let intervalId;

    const startTracking = () => {
      intervalId = setInterval(() => {
        handleFiveSecTimeSpentEvent({
          firebaseUID,
          userId: "",
          sourceScreen: screen,
        });
      }, 5000);
    };

    const stopTracking = () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        startTracking();
      } else {
        stopTracking();
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    if (document.visibilityState === "visible") {
      startTracking();
    }

    return () => {
      stopTracking();
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [userName, userId, screen]);
};

export default useFiveSecTimeSpent;
